export default __webpack_public_path__ + "static/media/fi-rr-envelope-marker.a29a9529.svg";